import React, { SVGAttributes } from 'react'

export const Logo: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width={32}
    height={24}
    viewBox="0 0 825 668"
    fill="currentColor"
    color="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#D8D8D8"
      d="M758.9,612.6H66.1l346.4-600l85.9,148.8c-110.5,0-200,89.5-200,200c0,110.5,89.5,200,200,200c74,0,138.6-40.2,173.2-100L758.9,612.6z"
    />
    <path fill="#C1754A" d="M698.4,361.4c0,36.4-9.7,70.6-26.8,100l-173.2-300C608.9,161.4,698.4,251,698.4,361.4z" />
  </svg>
)
